import React, { Suspense, useEffect, useState, useRef } from 'react'
import ResumesListing from './dashboard/ResumesListing';
import { connect } from 'react-redux';
import CoverLettersListing from './dashboard/CoverLettersListing';
import Cookie from 'js-cookie';
import { CHOOSE_COLOR, COOKIE_DOMAIN, COVERLETTER_EXPERIENCE, DASHBOARD_LINK } from '../constants/constants';
import CallOutBanner from './dashboard/CallOutBanner';
import { Redirect } from 'react-router';
const Dashboard = (props) => {
  const entityName = "Resume";
  const [tab, setTab] = useState(null);
  const mounted = useRef(false);
  const [createAction, setCreateAction] = useState(false);
  const [createCoverletterAction, setCreateCoverletterAction] = useState(false);
  const [resumeCount,setResumeCount] = useState();
  const [coverLetterCount,setCoverLetterCount] = useState();
  const [showGreetingMessage,setShowGreetingMessage] = useState(null);
  const [showParagraph, setShowParagraph] = useState(false);
  
  useEffect(() => {
      //browser issue, page not opening at top
      window.scrollTo(0, 0)
      mounted.current = true;
      return () => {
          mounted.current = false;
      };
  }, []);
  
  useEffect(() => {
    const letters = JSON.parse(localStorage.getItem('letters'))
    const l_count = letters && (typeof letters == 'object') && Object.keys(letters).length
    setCoverLetterCount ( l_count )
    //Dont show coverletter if coverletters are zero
    if(!l_count) toggleTab('resume')
    else if(tab === null ) toggleTab(Cookie.get('dashboard_tab', { domain: COOKIE_DOMAIN, path: "/" }) ?? 'resume')
  }, []);

  
  const toggleTab = (t) => {
    setTab(t);
    Cookie.set('dashboard_tab', t, {domain: COOKIE_DOMAIN, path: "/"});
  }

  const offlineResumesDoNotExist = () => {
    // Check for offline resume existance
    return (localStorage.getItem('offlineResumes') != null && JSON.parse(localStorage.getItem('offlineResumes')).length == 0) || (localStorage.getItem('offlineResumes') == null)
  }

  useEffect(()=>{
    if((Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && resumeCount === 0) || (!Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && offlineResumesDoNotExist())){
      setShowGreetingMessage('Effortless Resumes, Powered by AI');
      setShowParagraph(true)
    } else {
      setShowGreetingMessage('AIResumeBuilder Dashboard');
      setShowParagraph(false);
    }    
  },[resumeCount]);
  
  if (createAction) {
    history.pushState(null, DASHBOARD_LINK);
    return <Redirect to={CHOOSE_COLOR} />
  }
  if (createCoverletterAction) {
    history.pushState(null, DASHBOARD_LINK);
    return <Redirect to={COVERLETTER_EXPERIENCE} />
  }
  return <>
  <div className="deshboard-screen">
    <div className="container">
        <div className="create-new-mobile btn-resume" onClick={() => {
              gaTrack('RT App', 'Dashboard', `Create a New ${entityName}`);
              ga4Track('app_dashboard_create_button_mobile', 'RT App', `Create a New ${entityName} Mobile`);
            setCreateAction(true);
          }}>
            <span>+ Create New {entityName}</span>
        </div>
        <div className="create-new-mobile btn-cover" onClick={() => {
              gaTrack('RT App', 'Dashboard', `Create a New Coverletter`);
              ga4Track('app_dashboard_create_button_mobile', 'RT App', `Create a New Coverletter Mobile`);
            setCreateCoverletterAction(true);
          }}>
            <span>+ Create New Cover Letter</span>
        </div>
      <div className="deshboard-head">
        <h1>{showGreetingMessage != null ? showGreetingMessage : ''} </h1>
        {(Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"}) && props.user !== null) ? <div className="head-user"> Welcome Back! Ready to Update Your Resume{props.user.firstname != '' ? `, ${props.user.firstname} ${props.user.lastname}` : ''}?</div>
        : ( (localStorage.getItem('offlineResumes') !== null && JSON.parse(localStorage.getItem('offlineResumes')).length > 0) && <div className="head-user"> Welcome Back! Ready to Update Your Resume?</div>)
        }
        {/* Show paragraph if greeting message is 'Effortless Resumes, Powered by AI' */}
        {showParagraph && 
              <p className='no-resume-pera'>Build a professional resume in minutes with AI-driven suggestions and recruiter-approved templates.</p>
          }

        </div>
        {/* <CallOutBanner /> */}

      <div className="deshboard-tab-outer">
        { ((resumeCount  || coverLetterCount  )) ? <div className="tabs">
          <span id = 'resumetab' className={tab == 'resume' ? 'active' : ""} onClick={()=>toggleTab('resume')}>Resumes</span> 
          <span id = 'lettertab'className={tab == 'coverletter' ? 'active' : ""} onClick={()=>toggleTab('coverletter')}>Cover Letter</span>
        </div> : '' }
        <div className="tab-panel">
          {tab == null && 'Loading...'}
          {tab == 'resume'  &&  <ResumesListing setResumeCount={(resumeCount)=>setResumeCount(resumeCount)} {...props} />}
          {tab == 'coverletter'  &&  <CoverLettersListing {...props}  />}
        </div>
      </div>
     </div>
  </div>
  </>
 
}

export default connect(state => state)(Dashboard);